import { Auth0Provider } from '@auth0/auth0-react';
import React from 'react';
import { IS_CYPRESS } from '../lib/constants/is-cypress';
import { useSafeNavigate } from '../lib/url-utils/use-safe-navigate';

export const Auth0ProviderWithHistory: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const navigate = useSafeNavigate();

  const onRedirectCallback = React.useCallback(
    (appState?: { returnTo?: string }) => navigate(appState?.returnTo, window.location.pathname),
    [navigate],
  );

  return (
    <Auth0Provider
      audience={window.CONFIG.AUTH_AUDIENCE}
      cacheLocation={IS_CYPRESS ? 'localstorage' : 'memory'}
      clientId={window.CONFIG.AUTH_CLIENT_ID}
      domain={window.CONFIG.AUTH_DOMAIN}
      redirectUri={window.location.origin}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};
